<template>
  <section class="text-center">
    <div class="text-h6 error--text mb-2">{{ errorText }}</div>
    <v-btn v-if="retryFunction" color="secondary" @click="retryFunction">Reintentar</v-btn>
  </section>
</template>

<script>
export default {
  props: {
    errorText: {
      type: String,
      required: true,
    },

    retryFunction: {
      type: Function,
    },
  },
}
</script>
